<template>
  <container>
    <h1 style="font-size:25px;text-align:center">Promo Codes</h1>

  <div class="">
    
    <div  style="cursor: pointer;"  class="add-btn-content" >
      <img  style="float:left" @click="showAddPromoCodeModal"  src="../../../../assets/add-race.png" alt="Add icon"/>
      <div style="float: left;margin-top: 4px;margin-left: 5px;" @click="showAddPromoCodeModal">Create a new Promo Code</div>
      <div class="search_promo">
        <v-text-field
          placeholder="Search by Promo Code, Tag"
          v-model="searchPromoCode"
          @keyup.enter="handleSearchPromoCode"/>
      </div>
    </div>


    <div class="lucky-liverunner">
      <v-table         
        is-horizontal-resize
        style="width:100%;font-size:11px"
        :is-loading="loading"
        :columns="columns"
        :table-data="tableData"
        :paging-index="(pageIndex-1)*pageSize"
        @on-custom-comp="customCompFunc">
      </v-table>

      <div class="mt20 mb20 bold" style="padding-top:25px">
          <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :pageIndex ="pageIndex+1" :total="pageTotal" :page-size="pageSize" :layout="['total', 'prev', 'pager', 'next', 'sizer', 'jumper']"></v-pagination>
      </div>

      <add-promo-code :show="showAddPromoCode" @saved="onSaved" @closed="onClosed"></add-promo-code> 
      <edit-promo-code :promoData = "promoData" :show="showEditPromoCode" @saved="onSaved"  @closed="onClosed"></edit-promo-code> 
    
    </div>
  </div>


  </container>
</template>
<script>
let dialogOptions = {
    html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
    loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
    reverse: false, // switch the button positions (left to right, and vise versa)
    cancelText: 'No',
    okText: 'Yes',
    animation: 'zoom', // Available: "zoom", "bounce", "fade"
    type: 'basic', // coming soon: 'soft', 'hard'
    verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
    clicksCount: 3,
    animation: 'bounce', // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
  }
import Container from "@/components/Container"
import PromoCodeService from "../../../../services/promoCode"
import AddPromoCode from './AddPromoCode'
import EditPromoCode from './EditPromoCode'
import VTextField from '@/components/Forms/VTextField'
import { mapActions, mapGetters } from "vuex"
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
export default {
  name: "promoCodes",
  data() {
    return {
       columns: [
          {field: "id", title:'ID', width: 80, titleAlign: 'center',columnAlign:'center'},
          {field: "code", title:'Promo Code', width: 155, titleAlign: 'center',columnAlign:'center',isResize:true},
          {field: "totalTimesUsed", title:'Total Times Used', width: 120, titleAlign: 'center',columnAlign:'center'},
          {field: "usageLimit", title:'Usage Limit', width: 120, titleAlign: 'center',columnAlign:'center'},
          {field: "endTrialInDays", title:'End Trial In Days', width: 120, titleAlign: 'center',columnAlign:'center'}, 
          
          {field: "expirationDate", title:'Expiration Date', width: 135, titleAlign: 'center',
          columnAlign:'center', componentName:'convert-date'}, 
          {field: "tags", title:'Tags', width: 270, titleAlign: 'center',columnAlign:'center',
          componentName:'tags-list',isResize:true
          }, 
          {field: 'custome-adv',width: 100, title: '', titleAlign: 'center',columnAlign:'center',
            componentName:'edit-del'
          }           
          ],
      tableData:[],
      pageIndex:0,
      pageTotal:null,
      pageSize:20, 
      loading:false,
      showAddPromoCode:false ,
      showEditPromoCode:false,
      promoData:{},
      searchPromoCode:''
    }
  },
  computed: {
  },
  methods: {
     getAllPromoCode(){
      this.loading=true
      PromoCodeService.getAllPromoCodes(this.searchPromoCode,this.pageIndex,this.pageSize).then(response => {   
        //console.log("response---",response)
        this.tableData=response.data.content
        this.pageTotal = response.data.totalElements
        this.loading=false
      }).catch(error => {
        this.loading=false
        console.log("err--->>",error)
      })
    },
    customCompFunc(params){ 
      if(params.columeName == 'delete'){
        this.$dialog.confirm("Are you sure you want to delete '"+ params.rowData.code+"' promocode？", dialogOptions)
          .then((dialog) => {
            PromoCodeService.deletePromoCode(params.rowData.id).then(response => {
            this.$delete(this.tableData,params.index)
            }).catch(error => {
                console.log("err--->",error) 
              }) 
          })
      }else{
        this.showEditPromoCode = true
        this.promoData = params
      }
      
    },
    pageChange(pageIndex){
      this.pageIndex = pageIndex-1
      this.getAllPromoCode()        
    },
    pageSizeChange(pageSize){
      this.pageIndex = 0
      this.pageSize = pageSize
      this.getAllPromoCode()        
    },
    showAddPromoCodeModal(){
      this.showAddPromoCode=true
    },
    onClosed(){
      this.showAddPromoCode=false
      this.showEditPromoCode=false
    },
    onSaved(){
      this.getAllPromoCode()   
      this.showAddPromoCode=false
      this.showEditPromoCode=false
    },
    handleSearchPromoCode(){
      //console.log("in search>>>",this.searchPromoCode)
      this.pageIndex = 0
      this.getAllPromoCode()  
    }
  },
  created() {
    this.getAllPromoCode()  
  },
  watch: {},
  components: {
    Container,
    AddPromoCode,
    EditPromoCode,
    VTextField
  }
}

Vue.component('convert-date',{
  template:` <div>{{newdate}}
              </div>
            `,
  mounted () {
    //this.initdata()
  },
  data: () => ({
    newdate: ''
  }),
  props:{
    rowData:{
        type:Object
    },
    field:{
        type:String
    },
    index:{
        type:Number
    }      
  },
  methods:{
    initdata(){
      var utcDate = this.rowData.expirationDate
      if(utcDate !='' && utcDate!=null && utcDate!=undefined){
        this.newdate= moment(utcDate).format('YYYY-MM-DD')
      }else{
        this.newdate=''
      }
    },           
  },
  created () {
    this.initdata()
  },
  watch: {
      rowData: function (val) {
      this.initdata()
    },
  }
})

Vue.component('edit-del',{
        template:` <div class="edit_del_operation">
                        <button id="editBtn" @click.stop.prevent="edit()"></button>
                        <!--<button id="deleteBtn" @click.stop.prevent="deleteRunner()"></button> -->
                         <button id="deleteBtn" @click.stop.prevent="deleteRunner()"></button> 
                    </div>
                   `,
        data: () => ({
          path: ''
        }),
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
        },
        methods:{
          edit(){
            let params = {columeName:"edit",rowData:this.rowData,index:this.index}
            this.$emit('on-custom-comp',params)
          },
          deleteRunner(){
            let params = {columeName:"delete",rowData:this.rowData,index:this.index}
            this.$emit('on-custom-comp',params)
          },
          
        },
        created () {
        },
    })
Vue.component('tags-list',{
  template:` <div>{{tagList}}
              </div>
            `,
  mounted () {
    //this.initdata()
  },
  data: () => ({
    tagList: ''
  }),
  props:{
    rowData:{
        type:Object
    },
    field:{
        type:String
    },
    index:{
        type:Number
    }      
  },
  methods:{
    initdata(){
      if(this.rowData.tags){
        this.tagList = this.rowData.tags.map(a => a.name).toString()  
      }
    },           
  },
  created () {
    this.initdata()
  },
  watch: {
      rowData: function (val) {
      this.initdata()
    },
  }
})


</script>

<style>
.add-btn-content{
  margin: 15px 0;
  display: inline-block;
}
.search_promo{
  float: left;
  margin-left: 20px;
  margin-top: -7px;
}

.search_promo label .text-field{
  padding: 6.5px 55px 6.5px 20px!important;
}



</style>



// WEBPACK FOOTER //
// PromoCodes.vue?59552eae